import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { grey } from "@mui/material/colors";
import { useRecoilState } from "recoil";
import { filterState } from "../context/states";
import { theme } from "../styles/theme";
import IconContainer from "./icons/IconContainer";
import LocationIcon from "./icons/LocationIcon";

export const LocationCategorySelector = ({ categories, label }) => {
  const [filter, setFilter] = useRecoilState(filterState);

  const handleChanged = (event, category) => {
    let newSelectedCategories = [];

    if (!event.target.checked) {
      newSelectedCategories = (filter.categories ?? categories).filter(
        (c) => c.id !== category.id,
      );
    } else {
      newSelectedCategories = [...(filter.categories ?? categories), category];
    }

    setFilter({ ...filter, categories: newSelectedCategories });
  };

  const CategoryFilter = (props) => {
    const { isChecked, category } = props;
    return (
      <Box sx={categoryFilterStyles(isChecked, category)}>
        <Box className="category-filter-background"></Box>
        <Grid container justifyContent="center">
          <Grid item xs="auto" className="category-icon">
            <IconContainer color={category.color}>
              <LocationIcon category={category} />
            </IconContainer>
          </Grid>
          <Grid item xs={12}>
            <Typography className="category-name">{category.name}</Typography>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <>
      {label && <InputLabel>{label}</InputLabel>}
      <Box display="grid" sx={categoryGridStyles}>
        {categories.map((category) => {
          const isChecked = (filter.categories ?? categories).some(
            (c) => c.id === category.id,
          );
          return (
            <FormControlLabel
              key={category.id}
              sx={categoryFilterWrapperStyles}
              control={
                <Switch
                  sx={{ display: "none" }}
                  checked={isChecked}
                  onChange={(event) => handleChanged(event, category)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label={
                <CategoryFilter isChecked={isChecked} category={category} />
              }
            ></FormControlLabel>
          );
        })}
      </Box>
    </>
  );
};

const categoryGridStyles = {
  gridTemplateColumns: "repeat(2, 1fr)",
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  [theme.breakpoints.up("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  borderRadius: "0.25rem",
  backgroundColor: grey[200],
  gap: "1px",
  borderColor: grey[200],
  borderStyle: "solid",
  borderWidth: "1px",
};

const categoryFilterWrapperStyles = {
  margin: 0,
  width: "100%",
  display: "block",
  zIndex: "500",
  position: "relative",
  padding: "0.75rem",
  "& > .MuiTypography-root": {
    display: "block",
    width: "100%",
    height: "100%",
  },
};

const categoryFilterStyles = (isChecked, category) => {
  return {
    height: "100%",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      "& .category-filter-background": {
        [theme.breakpoints.up("md")]: {
          backgroundColor: isChecked ? category.color : "white",
          opacity: 0.1,
        },
      },
    },
    "& .category-name": {
      textAlign: "center",
      marginTop: "0.25rem",
      fontSize: "0.875rem",
      lineHeight: "1.15rem",
      color: isChecked ? theme.palette.common.black : grey[500],
    },
    "& .category-icon": {
      opacity: isChecked ? 1 : 0.15,
    },
    "& .category-filter-background": {
      zIndex: "-100",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "white",
    },
  };
};
